export function toggleWrapScroll() {
  document.getElementById('wrapper').classList.toggle("freeze")
}